module.exports = __webpack_public_path__ + "img/one-source.5fc3aaaa.svg";